<template>
    <div class="p-5 md:p-20 flex space-x-10 md:space-x-20">
        <div class="w-1/2 flex space-y-10 flex-col">
            <h2 class="text-7xl font-semibold">{{ destination.name }}<span v-if="destination.parent">,<br>{{ destination.parent.name }}</span></h2>
            <editable-input-field v-model="form.heading" size="l" />
            <editable-text-area v-model="form.description" />
        </div>
        <div class="relative py-4 mx-6 h-96 md:py-0 md:mx-0 md:mr-14 md:w-1/2">
            <GMapMap
                :center="{
                    lat: destination.location.coordinates[1],
                    lng: destination.location.coordinates[0]
                }"
                :zoom="8"
                map-type-id="terrain"
                :options="{
                      scrollwheel: false,
                      zoomControl: false,
                      mapTypeControl: false,
                      scaleControl: false,
                      streetViewControl: false,
                      rotateControl: false,
                      fullscreenControl: false,
                }"
                style="position: absolute; width: 100%; height: 100%; border-radius: 6px"
            >
                <GMapMarker
                    :position="{
                        lat: destination.location.coordinates[1],
                        lng: destination.location.coordinates[0]
                    }"
                />
            </GMapMap>
        </div>
    </div>
</template>

<script setup>

import EditableTextArea from "@/ComponentsDeprecated/Proposal/EditableTextArea";
import EditableInputField from "@/ComponentsDeprecated/Proposal/EditableInputField";
import {reactive, watch} from "vue";
import {notify} from "notiwind";

const props = defineProps({
    destination: {
        required: true,
        type: Object
    }
})

const form = reactive({
    place_id: props.destination.id,
    heading: props.destination.pivot.heading,
    description: props.destination.pivot.description
})
watch(form, () => {
    axios.post(route('api.proposal.place.store', {proposal: props.destination.pivot.proposal_id, place: props.destination.id}), form)
        .then(() => {
            notify({
                type: 'success',
                title: 'Saved',
                text: 'Destination ' + props.destination.name + ' saved',
            }, 4000)
        }).catch(error => {
        notify({
            type: 'danger',
            title: 'Something went wrong',
            text: 'Could not save destination ' + props.destination.name,
        }, 4000)
        console.log(error)
    }).finally(() => {

    })
})

</script>
